import { HomeIcon, UsersIcon } from '@heroicons/vue/24/outline'

/** Guest “Explore” links shown in the landing-style mobile drawer (Home excluded in UI via filter). */
export const landingGuestExploreLinks = [
  { name: 'Home', description: 'Home', href: '/', icon: HomeIcon },
  { name: 'Meet the Team', description: 'Meet the Team', href: '/about-us', icon: UsersIcon }
]
